import {gql, useMutation} from "@apollo/client";

const ADD_GROUP_MUTATION = gql`
mutation CreateGroup($name: String!, $stageId: Int!) {
  createGroup(name: $name, stageId: $stageId) {
    group{
        id
        name
    }
  }
}

`;

export default function AddGroupMutation() {
    return useMutation(ADD_GROUP_MUTATION);
}